import React from "react";
import { PodcastsPageTemplate } from "themes/application/categories/pages";
import { PodcastsViewStore } from "application/categories/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView((rootStore, componentProps) => new PodcastsViewStore(rootStore, componentProps), "podcastsViewStore")
class PodcastsPage extends React.Component {
    render() {
        return <PodcastsPageTemplate {...this.props} />;
    }
}

export default PodcastsPage;
